import React from 'react';
import { CheckIcon } from 'lucide-react';
const RESOURCES = ['Visual diagnostic maps.', 'Troubleshooting flows.', 'Electrical references.', 'Airflow pathways.', 'Pressure patterns.', 'Component diagnostics.', 'Testing sequences.', 'Symptom-based troubleshooting maps.'];
export function StopSearching() {
  return <section className="bg-off px-4 py-5 sm:py-7" data-id="element-166" data-mp="2dt682l4me3jd">
      <div className="mx-auto max-w-3xl" data-id="element-167" data-mp="28ubjf2jz1krc">
        <h2 className="text-center text-xl leading-tight text-navy sm:text-3xl" data-id="element-168" data-mp="28w63kenf58ud">
          😩 Stop searching for what to check next
        </h2>
        <p className="mt-2 text-sm font-medium leading-snug text-charcoal/80 sm:text-base" data-id="element-169" data-mp="1z4rzruofpmvf">
          Your time should go into troubleshooting the system — not searching through
          disconnected charts, manuals and saved references.
        </p>
        <p className="mt-1 text-sm font-semibold leading-snug text-navy sm:text-base" data-id="element-170" data-mp="1q3kb84bq00ej">
          HVAC DIAGNOSTIC READY™ brings the resources together for you.
        </p>

        <ul className="mt-3 grid gap-1.5 sm:grid-cols-2" data-id="element-171" data-mp="1wzgjvqmy7jfw">
          {RESOURCES.map(item => <li key={item} className="flex items-start gap-2 rounded-md border border-navy/10 bg-white px-3 py-2 text-sm font-semibold text-charcoal" data-id="element-172" data-mp="21qou2ow3r8u4">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-service" aria-hidden="true" strokeWidth={3} data-id="element-173" data-mp="1sxlm2w487o6v" />
              {item}
            </li>)}
        </ul>

        <p className="mt-3 text-sm font-medium leading-snug text-charcoal/80 sm:text-base" data-id="element-174" data-mp="2koreeqdpghll">
          Everything organized so you can identify the relevant pathway, follow the checks and
          verify findings using professional judgment and equipment-specific information.
        </p>
        <p className="mt-2 text-center font-display text-lg uppercase text-service sm:text-2xl" data-id="element-175" data-mp="v9l9o3lkp5kx">
          Less searching. More structured troubleshooting.
        </p>
      </div>
    </section>;
}